var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChevronRight = function SvgChevronRight(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M14.75 10a.95.95 0 0 1-.32.707l-6.563 6c-.427.39-1.12.39-1.547 0a.94.94 0 0 1 0-1.414l5.791-5.292-5.79-5.294a.94.94 0 0 1 0-1.414c.428-.39 1.12-.39 1.547 0l6.562 6c.214.195.32.451.32.708"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChevronRight);
export default ForwardRef;